import { lazy } from 'react';
import { SuspenseLoader } from '@router/components';
import { DRUG_SCREEN_ROUTE_ID } from '@constants/routeIds';
import { drugScreenLoader } from './drugScreenLoader';
import {
  DRUG_SCREEN_ROUTE_PATHNAME,
  DRUG_SCREEN_REQUEST_DRUG_SCREEN_KIT_ROUTE_PATHNAME,
  DRUG_SCREEN_REQUEST_LAB_FORMS_ROUTE_PATHNAME,
  DRUG_SCREEN_KIT_CHECK_ROUTE_PATHNAME,
  DRUG_SCREEN_UPLOAD_RESULTS_ROUTE_PATHNAME,
} from '../routePathnames';

const DrugScreenPage = lazy(() => import('@pages/DrugScreen/DrugScreenPage'));
const RequestDrugScreenKitPage = lazy(
  () =>
    import(
      '@pages/DrugScreen/RequestDrugScreenKitPage/RequestDrugScreenKitPage'
    ),
);
const RequestLabFormsPage = lazy(
  () => import('@pages/DrugScreen/RequestLabFormsPage/RequestLabFormsPage'),
);
const DrugScreenKitCheckPage = lazy(
  () => import('@pages/DrugScreen/DrugScreenKitCheckPage'),
);
const UploadDrugScreenPage = lazy(
  () => import('@pages/DrugScreen/UploadDrugScreenPage/UploadDrugScreenPage'),
);

export const drugScreenRoutes = [
  {
    id: DRUG_SCREEN_ROUTE_ID,
    path: `${DRUG_SCREEN_ROUTE_PATHNAME}/:visitTypeId`,
    element: (
      <SuspenseLoader>
        <DrugScreenPage />
      </SuspenseLoader>
    ),
    loader: drugScreenLoader,
  },
  {
    id: `${DRUG_SCREEN_ROUTE_ID}-request-drug-screen-kit`,
    path: DRUG_SCREEN_REQUEST_DRUG_SCREEN_KIT_ROUTE_PATHNAME,
    element: (
      <SuspenseLoader>
        <RequestDrugScreenKitPage />
      </SuspenseLoader>
    ),
    loader: drugScreenLoader,
  },
  {
    id: `${DRUG_SCREEN_ROUTE_ID}-request-lab-forms`,
    path: DRUG_SCREEN_REQUEST_LAB_FORMS_ROUTE_PATHNAME,
    element: (
      <SuspenseLoader>
        <RequestLabFormsPage />
      </SuspenseLoader>
    ),
    loader: drugScreenLoader,
  },
  {
    id: `${DRUG_SCREEN_ROUTE_ID}-drug-screen-kit-check`,
    path: DRUG_SCREEN_KIT_CHECK_ROUTE_PATHNAME,
    element: (
      <SuspenseLoader>
        <DrugScreenKitCheckPage />
      </SuspenseLoader>
    ),
    loader: drugScreenLoader,
  },
  {
    id: `${DRUG_SCREEN_ROUTE_ID}-upload-drug-screen`,
    path: DRUG_SCREEN_UPLOAD_RESULTS_ROUTE_PATHNAME,
    element: (
      <SuspenseLoader>
        <UploadDrugScreenPage />
      </SuspenseLoader>
    ),
    loader: drugScreenLoader,
  },
];
